import styled from 'styled-components';

const Footer = styled.p`
  font-size: 0.5em;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  font-weight: 800;
`;

export default Footer;
